import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const otpApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}user/otp`,
        method: "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
        }
    })

    return response

}

export default otpApi